
import BaseFilter from '@/components/filters/Filter';
import { Option } from '@/components/SelectPicker.vue';

export const modes = {
	permissive: {
		id: 'permissive',
		operator: 'OR',
	},

	strict: {
		id: 'strict',
		operator: 'AND',
	}
};

type Mode = keyof typeof modes;

type ValueType = {
	low: string;
	high: string;
	mode: Mode;
};

export default BaseFilter.extend({
	props: {
		value: {
			type: Object as () => ValueType,
			required: true,
			default: () => ({
				low: '',
				high: '',
				mode: 'strict'
			}) as ValueType
		},
	},
	computed: {
		fields(): { low: string, high: string, mode?: keyof typeof modes } { return this.definition.metadata; },
		modes(): Option[] {
			return Object.values(modes).map<Option>(m => ({
				value: m.id,
				label: this.$td(`filter.range.${m.id}`, m.id),
				title: this.$td(`filter.range.${m.id}_description`, m.id)
			}))
		},
	}
});
